import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function Success({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="8" cy="8" r="6" fill={color}/>
            <path d="M5.52081 7.70833L7.27081 9.75L10.4791 6.25" stroke="white" strokeWidth="1.2"
                strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default Success;
